import { render, staticRenderFns } from "./MaskB.vue?vue&type=template&id=13221d58&scoped=true&"
import script from "./MaskB.vue?vue&type=script&lang=js&"
export * from "./MaskB.vue?vue&type=script&lang=js&"
import style0 from "./MaskB.vue?vue&type=style&index=0&id=13221d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13221d58",
  null
  
)

component.options.__file = "MaskB.vue"
export default component.exports